<template>
  <div class="modal-mask">
    <div class="modal-content-container">
      <div class="invitations-header-container">
        <span class="invitations-header-title"> Convites </span>
        <span @click="closeDialog" class="material-icons closebtn-icon"> cancel </span>
      </div>

      <div class="invitations-modal-body-container">
        <div v-if="!isNewInvitationFormOpen" class="invitations-actions-container">
          <cc-select-v2
            class="status-input"
            tracker="code"
            :text="'name'"
            :placeholder="'Selecione um status'"
            @input="set_status_filter"
            :options="statuses"
            v-model="status_filter"
          >
          </cc-select-v2>

          <div class="invitations-buttons-container">
            <StandardButton
              style="margin-right: 20px"
              :iconName="'email'"
              :text="'Novo Convite'"
              :action="showNewInvitationForm"
            />
            <StandardButton
              :iconName="'notifications_active'"
              :text="'Reenviar Notificação'"
              :action="renotify"
            />
          </div>
        </div>

        <!-- Formulário de Novo Convite -->
        <div v-if="isNewInvitationFormOpen">
          <ValidationObserver v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(save)">
              <div class="invitations-form-container">
                <div class="invitations-form-row">
                  <div class="invitations-input-half">
                    <ValidationProvider rules="required" v-slot="v">
                      <div class="invitations-input-title">
                        Nome: <span class="required-field">*</span>
                      </div>
                      <div class="invitations-input-wrapper">
                        <input
                          class="invitations-input-value"
                          type="text"
                          v-model="invitation.receiver_name"
                          :readonly="invitation.lock"
                        />
                      </div>
                      <span class="invitations-error-message">{{ v.errors[0] }}</span>
                    </ValidationProvider>
                  </div>

                  <div class="invitations-input-half">
                    <ValidationProvider rules="required|phone" v-slot="v">
                      <div class="invitations-input-title">
                        Telefone: <span class="required-field">*</span>
                      </div>
                      <div class="invitations-input-wrapper">
                        <input
                          class="invitations-input-value"
                          v-mask="'(##) ####-#####'"
                          type="text"
                          v-model="invitation.receiver_phone"
                          @focus="unlock_invitation"
                          :readonly="invitation.lock"
                          @blur="search_by_phone"
                        />
                      </div>
                      <span class="invitations-error-message">{{ v.errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>

                <div class="invitations-form-row">
                  <div class="invitations-input-full">
                    <div class="invitations-input-title">Empresa:</div>
                    <div class="invitations-input-wrapper">
                      <input
                        class="invitations-input-value"
                        type="text"
                        v-model="invitation.receiver_company_name"
                        :readonly="invitation.lock"
                      />
                    </div>
                  </div>
                </div>

                <div class="invitations-form-buttons">
                  <StandardButton
                    style="margin-right: 20px"
                    :iconName="'arrow_back'"
                    :text="'Voltar'"
                    :action="
                      () => {
                        isNewInvitationFormOpen = false;
                      }
                    "
                  />
                  <StandardButton
                    :iconName="'mail'"
                    type="submit"
                    :text="'Enviar'"
                    :action="
                      () => {
                        handleSubmit(save);
                      }
                    "
                  />
                </div>
              </div>
            </form>
          </ValidationObserver>
        </div>

        <!-- Lista de Convites -->
        <cc-loader v-show="loading" />
        <no-data-available
          v-if="!loading && invitations && invitations.length === 0"
          :text="'Sem convites enviados'"
        />

        <div
          v-show="!loading && invitations.length > 0"
          class="invitations-table-container"
        >
          <div class="invitations-table-wrapper">
            <div class="invitations-table-header">
              <div class="invitations-table-header-column envelope-column"></div>
              <div class="invitations-table-header-column name-column">Nome</div>
              <div class="invitations-table-header-column phone-column">Telefone</div>
              <div class="invitations-table-header-column company-column">Empresa</div>
              <div class="invitations-table-header-column date-column">Enviado em</div>
              <div class="invitations-table-header-column status-column">Status</div>
              <div class="invitations-table-header-column whatsapp-column">Status Whatsapp</div>
            </div>

            <div
              v-for="(invitation, idx) in invitations"
              :key="invitation.id"
              :class="{
                canceled: invitation.status == 'CANCELED',
                waiting: invitation.status == 'WAITING_CONFIRMATION',
                confirmed: invitation.status == 'CONFIRMED',
              }"
            >
              <div :class="getSpecialBackground(idx)" class="invitations-table-row">
                <div class="invitations-table-column envelope-column">
                  <span class="material-icons-round email">email</span>
                </div>
                <div class="invitations-table-column name-column">
                  <div class="mobile-header">Nome</div>
                  {{ invitation.receiver_name }}
                </div>
                <div class="invitations-table-column phone-column">
                  <div class="mobile-header">Telefone</div>
                  <cc-whatsapp :phone="invitation.receiver_phone" />
                </div>
                <div class="invitations-table-column company-column">
                  <div class="mobile-header">Empresa</div>
                  {{ invitation.receiver_company_name }}
                </div>
                <div class="invitations-table-column date-column">
                  <div class="mobile-header">Enviado em</div>
                  {{ invitation.created_at | formatDate }}
                </div>
                <div class="invitations-table-column status-column">
                  <div class="mobile-header">Status</div>
                  <cc-select-v2
                    class="status-select"
                    tracker="code"
                    :text="'name'"
                    @input="
                      (s) => {
                        set_status(invitation, s);
                      }
                    "
                    :options="statuses"
                    v-model="invitation.selected_status"
                  >
                  </cc-select-v2>
                </div>
                <div class="page-table-desc-column whatsapp-column">
                  <div v-if="invitation.status_whatsapp=='read'">
                    <Tooltip :text="'Enviado: ' + invitation.whatsapp_sent_datetime + '\nEntregue: ' + invitation.whatsapp_delivered_datetime + '\nLido: ' + invitation.whatsapp_read_datetime" position="left">
                      <span class="material-icons whatsapp-read">done_all</span>
                    </Tooltip>
                  </div>
                  <div v-else-if="invitation.status_whatsapp=='delivered'">
                    <Tooltip :text="'Enviado: ' + invitation.whatsapp_sent_datetime + '\nEntregue: ' + invitation.whatsapp_delivered_datetime " position="left">
                      <span class="material-icons whatsapp-tick" >done_all</span>
                    </Tooltip>
                  </div>
                  <div v-else-if="invitation.status_whatsapp=='sent'">
                    <Tooltip :text="'Enviado: ' + invitation.whatsapp_sent_datetime" position="left">
                      <span class="material-icons whatsapp-tick">check</span>                
                    </Tooltip>
                  </div>
                  <div v-else>
                    <span class="material-icons whatsapp-error">error</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="invitations-pagination" v-show="total_items > 1">
            <Pagination
              classes="orange justify-end"
              :total="total_items"
              :items_by_page_value="15"
              :page="page"
              :page_limit="9"
              @change="load"
            >
            </Pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InvitationService from "@/services/v3/invitation.service";
import ProviderService from "@/services/v3/provider.service";
import QuotationService from "@/services/QuotationService";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { loaderMixin } from "@/mixins/sweet-loader.mixin";
import Pagination from "@/components/cliente/base-components/Pagination";
import StandardButton from "@/components/ui/buttons/StandardButton.vue";
import Tooltip from "@/components/Tooltip.vue";

export default {
  mixins: [loaderMixin],
  props: ["client", "closeDialog"],
  components: {
    Pagination,
    ValidationProvider,
    ValidationObserver,
    StandardButton,
    Tooltip,
  },
  data() {
    return {
      svc: new InvitationService(),
      pro_svc: new ProviderService(),
      req_svc: new QuotationService(),
      invitations: [],
      invitation: null,
      loading: true,
      status_filter: null,
      total_items: 0,
      page: 1,
      statuses: [
        { name: "Aguardando Confirmação", code: "WAITING_CONFIRMATION" },
        { name: "Confirmado", code: "CONFIRMED" },
        { name: "Cancelado", code: "CANCELED" },
      ],
      isNewInvitationFormOpen: false,
    };
  },
  created() {
    this.load();
  },
  methods: {
    async sendInvite(invitation) {
      return this.svc
        .send(invitation)
        .then((response) => response.data)
        .catch((e) => e.response.data);
    },

    async testPhone(phone) {
      return this.pro_svc
        .find_by_phone(phone)
        .then((response) => response.data)
        .catch(() => "erro");
    },

    showNewInvitationForm() {
      this.invitation = { lock: false };
      this.isNewInvitationFormOpen = true;
    },

    getRowBackgroundClass(idx) {
      return idx % 2 !== 0 ? "alternate-row" : "";
    },

    getStatusClass(status) {
      return status.toLowerCase().replace("_", "-");
    },

    set_status_filter(s) {
      this.status_filter = s;
      this.load();
    },

    set_status(invitation, s) {
      invitation.selected_status = s;
      invitation.status = s.code;
      this.svc.update_status({ id: invitation.id, status: s.code }).then(() => {
        invitation.saved = true;
        this.$forceUpdate();
      });
    },

    save() {
      this.present_loader("Enviando convite...");

      this.search_by_phone(() => {
        this.invitation.cli_id = this.client.id;
        this.svc
          .send(this.invitation)
          .then(() => {
            if (this.invitation.invited_user_id) {
              this.req_svc.enableSeller(this.invitation.invited_user_id, this.client.id);
              this.$emit("load_sellers");
            }
            this.load()
              .then(() => this.dismiss_loader())
              .then(() => {
                this.invitation = null;
                this.isNewInvitationFormOpen = false;
              });
          })
          .catch((err) => {
            if (err.response?.data?.errors) {
              this.$store.dispatch("notification/add", {
                type: "error",
                message: err.response.data.errors[0],
              });
            }
            this.dismiss_loader();
          });
      });
    },

    cancel(invitation) {
      this.confirm_action({
        message: "Confirma cancelamento do convite?",
        callback: () => {
          this.present_loader("Cancelando Convite...");
          this.svc
            .cancel(invitation)
            .then(() => this.load())
            .then(() => this.dismiss_loader());
        },
      });
    },

    renotify() {
      this.confirm_action({
        message: "Confirma reenvio de notificações dos convites pendentes?",
        callback: () => {
          this.present_loader("Reenviando notificações...");
          this.svc
            .notify_all(this.client)
            .then(() => this.present_info("Notificações Enviadas!"));
        },
      });
    },

    unlock_invitation() {
      this.$set(this.invitation, "lock", false);
      this.invitation.invited_user_id = null;
    },

    search_by_phone(callback = null) {
      return this.pro_svc
        .find_by_phone(this.invitation.receiver_phone)
        .then((response) => {
          const data = response.data;
          this.invitation.receiver_name = data.usu_nome;
          this.invitation.receiver_company_name = data.provider.for_nome;
          this.invitation.invited_user_id = data.usu_id;
          this.invitation.cli_id = this.client.id;
          this.$set(this.invitation, "lock", true);
          if (callback) callback(response);
        })
        .catch(() => {
          if (callback) callback(null);
        });
    },

    load(page = this.page) {
      this.loading = true;
      this.page = page;

      return this.svc
        .list({
          client_id: this.client.id,
          page,
          status: this.status_filter?.code,
        })
        .then((response) => {
          const data = response.data;
          this.invitations = data.data.map((i) => ({
            ...i,
            selected_status: this.statuses.find((s) => s.code === i.status),
          }));
          this.total_items = data.total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getEnvelopeColor(status) {
      switch (status) {
        case "CANCELED":
          return "envelope-canceled";
        case "WAITING_CONFIRMATION":
          return "envelope-waiting";
        case "CONFIRMED":
          return "envelope-confirmed";
        default:
          return "";
      }
    },
    getSpecialBackground(idx) {
      if (idx % 2 != 0) return "page-table-line-special";
    },
    handlekeydown(e) {
      if (e.key === "Escape") {
          this.closeDialog()
      }
    }
  },
  mounted() {
		window.addEventListener('keydown', this.handlekeydown);
	},
	beforeDestroy(){
		window.removeEventListener('keydown', this.handlekeydown);
	}
};
</script>

<style lang="scss" scoped>
@import "@/sass/commons/_variables";

.modal-mask {
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;
}

.modal-content-container {
  background-color: white;
  width: 80vw;
  max-width: 1200px;
  max-height: 100vh;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.invitations-header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background-color: var(--primary-color);
  color: white;
}

.invitations-header-title {
  font-weight: 500;
  font-size: 1.5rem;
}

.closebtn-icon {
  cursor: pointer;
  font-size: 1.8rem;
  color: white;
}

.invitations-modal-body-container {
  padding: 20px;
  overflow-y: auto;
  flex-grow: 1;
}

.invitations-actions-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  gap: 20px;
}

.status-input {
  flex: 1;
  max-width: 400px;
}

.invitations-buttons-container {
  display: flex;
  gap: 15px;
}

.invitations-form-container {
  margin-bottom: 30px;
}

.invitations-form-row {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.invitations-input-half {
  flex: 1;
  min-width: 0;
}

.invitations-input-full {
  flex: 1;
  width: 100%;
}

.invitations-input-title {
  font-weight: 400;
  font-size: 1rem;
  color: #898989;
  margin-bottom: 8px;
}

.required-field {
  color: $brand-danger;
}

.invitations-input-wrapper {
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  padding: 12px 15px;
  display: flex;
  align-items: center;
}

.invitations-input-value {
  border: none;
  flex: 1;
  font-size: 1rem;
  color: #333;
  width: 100%;
  background: transparent;

  &:focus {
    outline: none;
  }

  &:read-only {
    color: #b3b3b3;
    background-color: #f5f5f5;
  }
}

.invitations-error-message {
  color: $brand-danger;
  font-size: 0.8rem;
  margin-top: 5px;
  display: block;
}

.invitations-form-buttons {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.invitations-table-container {
  margin-top: 20px;
}

.invitations-table-wrapper {
  overflow-x: auto;
}

.invitations-table-header {
  display: flex;
  background: #fffefc;
  border: 1px solid #e5e5e5;
  font-weight: 600;
  color: #505050;
  padding: 12px 0;
}

.invitations-table-header-column {
  padding: 0 10px;
  font-size: 0.9rem;
}

.invitations-table-row {
  display: flex;
  padding: 12px 0;
  font-size: 0.9rem;
  color: #605f5f;
}

.invitations-table-column {
  padding: 0 10px;
  display: flex;
  align-items: center;
}

.envelope-column {
  width: 5%;
  justify-content: center;
}

.name-column {
  width: 16%;
}

.phone-column {
  width: 16%;
}

.company-column {
  width: 16%;
}

.date-column {
  width: 14%;
}

.status-column {
  width: 22%;
}
.whatsapp-column {
  width: 8%;
}

.whatsapp-tick{
  color: gray;
}
.whatsapp-read{
  color: blue;
}
.whatsapp-error{
  color: red;
}

.alternate-row {
  background-color: #f7f7f7;
}

.waiting-confirmation {
  .email{
    color: $yellow2;
  }
}

.confirmed {
  .email{
    color: $ternary-color;
  }
}

.canceled {
  .email{
    color: $brand-danger;
  }
}

.status-select {
  width: 100%;
}

.invitations-pagination {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.mobile-header {
  display: none;
  font-weight: 600;
  margin-right: 10px;
}

.envelope-canceled {
  color: $brand-danger;
}

.envelope-waiting {
  color: $yellow2;
}

.envelope-confirmed {
  color: $ternary-color;
}

.canceled {
  span:not(.envelope-canceled) {
    .email{
      color: $brand-danger;
    }
  }
}

.waiting {
  span:not(.envelope-waiting) {
    .email{
      color: $yellow2;
    }
  }
}

.confirmed {
  span:not(.envelope-confirmed) {
    .email {
      color: $ternary-color;
    }
  }
}

.page-table-line-special {
  background: #f7f7f7;
}

@media only screen and (max-width: 768px) {
  .modal-content-container {
    width: 95vw;
    max-height: 95vh;
  }

  .invitations-actions-container {
    flex-direction: column;
    align-items: flex-start;
  }

  .status-input {
    max-width: 100%;
    width: 100%;
    margin-bottom: 15px;
  }

  .invitations-buttons-container {
    width: 100%;
    justify-content: space-between;
  }

  .invitations-form-row {
    flex-direction: column;
    gap: 15px;
  }

  .invitations-table-header {
    display: none;
  }

  .invitations-table-row {
    flex-direction: column;
    padding: 15px;
    border-bottom: 1px solid #e5e5e5;
  }

  .invitations-table-column {
    width: 100% !important;
    padding: 8px 0;
    justify-content: space-between;
  }

  .mobile-header {
    display: inline-block;
  }

  .status-select {
    width: 60%;
  }
}
</style>
